// extracted by mini-css-extract-plugin
export default {"balancedHeading":"SecondPillarPaymentRate_balancedHeading__m7nCe"};